import { useEffect } from "react";

import { useRealTimeTypedQuery } from "components";
import { useKioskLabelsListeners } from "modules/KioskDashboard/components/KioskLabelsModal/listeners";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useKiosksLabelsQuery = (kioskId?: number) => {
  const listeners = useKioskLabelsListeners();

  const query = useRealTimeTypedQuery({
    queryKey: KioskDashboardQueryKeys.labels,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { kiosk_id: kioskId }, baseUrl)).data.labels,
    enabled: Boolean(kioskId),
    listeners
  });

  useEffect(() => {
    if (kioskId) query.refetch();
  }, [kioskId]);

  return query;
};
